export const CREATE = "CREATE";
export const UPDATE = "UPDATE";
export const DELETE = "DELETE";
export const FETCH_ALL = "FETCH_ALL";
export const LIKE = "LIKE";
export const COMMENT = "COMMENT";
export const FETCH_BY_SEARCH = "FETCH_BY_SEARCH";

export const ADD_TO_CART = "ADD_TO_CART";
export const REMOVE_FROM_CART = "REMOVE_FROM_CART";
export const RESET_CART = "RESET_CART";
export const CHANGE_QTY = "CHANGE_QTY";
export const CLEAR_ADD_NOTICE = "CLEAR_ADD_NOTICE";

export const AUTH = "AUTH";
export const LOGOUT = "LOGOUT";
export const UPDATE_USER = "UPDATE_USER";

export const AUTH_ERROR = "AUTH_ERROR";
export const CLEAR_AUTH_ERROR = "CLEAR_AUTH_ERROR";
